/*
-------------------------------------------------
  FUNCTION TO CHECK FOR QUESTIONS AND QUIZZES.
-------------------------------------------------
*/
/* eslint-disable*/

var checkSoaFMSubscription = function checkSoaFMSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            // inside if block subscription check for partner users.
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          } else {
            /*
            ---------------
              App User's
            ---------------
            */
            // inside else block check for partner user app subsciption plans
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          }
        }
      } else {
        flag = true;
      }
      break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            // inside if block subscription check for partner users plans
            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              flag = true;
              break;
            }
          } else {
            /*
            --------------
              App User's
            --------------
            */
            // inside else check for block partner user subscription plans
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 28 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
  }
  return flag;
};

/*
-------------------------------
  FUNCTION TO CHECK FOR NOTES
-------------------------------
*/
var checkSoaFMNotesSubscription = function checkSoaFMNotesSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          } else {
            /*
            ------------------
              App User's
            ------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            }
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */

            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35 &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          } else {
            /*
          --------------
            App User's
          --------------
          */
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 28 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35 &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
  }

  return flag;
};

/*
-----------------------------------------------------
  FUNCTION TO CHECK FOR PDF'S DOWNLOAD
-----------------------------------------------------
*/
var checkSoaFM_PDFSubscription = function checkSoaFM_PDFSubscription(
  selectedLevel,
  exam_data,
  type
) {
  var pdfFlag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            // inside if block subscription check for partner user
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive // simple check
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true; // for questions
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes" // for notes
              ) {
                pdfFlag = true;
              }
              // break;/
            }
          } else {
            /*
            ------------------
              App User's
            ------------------
            */
            // inside else block subscriptin check for partner user app plans
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;/
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              // break;
            }
          }
        }
      } else {
        pdfFlag = true;
      }
    } else {
      // inside else block check for other exams app and partner subscription plans
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            -------------------
            */

            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;
            }
          } else {
            /*
            ----------------
              App User's
            ----------------
            */

            // inside else block subscription check for partner user app plans
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 28 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              pdfFlag = true;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;
            }
          }
        }
      }
    }
  }

  return pdfFlag;
};

/*
-----------------------------------------------------
  FUNCTION TO CHECK FOR VIDEOS
-----------------------------------------------------
*/

var checkSoaFMVideosSubscription = function checkSoaFMVideosSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            // inside if block subscription check for partner user
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;/
            }
          } else {
            /*
            ------------------
              App User's
            ------------------
            */

            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;/
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              // break;
            }
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 28 ||
              exam_data[i].levels[j].package_id === 34 ||
              exam_data[i].levels[j].package_id === 36)
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }
  return flag;
};
exports.checkSoaFMSubscription = checkSoaFMSubscription;
exports.checkSoaFMNotesSubscription = checkSoaFMNotesSubscription;
exports.checkSoaFM_PDFSubscription = checkSoaFM_PDFSubscription;
exports.checkSoaFMVideosSubscription = checkSoaFMVideosSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/SoaFMSubscription.js